import { PERMISSIONS_VIEWS } from "config/userPermissions";
import AppointmentManualLoadingForm from "../components/AppointmentManualLoadingForm/AppointmentManualLoadingForm";
import AppointmentSchedules from "../components/AppointmentSchedules/AppointmentSchedules";

export const STEPS_DESCRIPTION = [
    "Detalles de asesoría",
    "Ubicación y público", 
    "Vista previa y confirmación"
];
export const TOAST_MUST_CORRECT_MSG = {
    INVALID_OR_INCOMPLETED: "Te faltan completar campos o existen campos inválidos.",
    TIME_CROSSING: "El horario de asesoría para el psicólogo que seleccionaste genera cruces."
};
const { ASESORIAS } = PERMISSIONS_VIEWS;
export const APPOINTMENT_MODULES = [
    { 
        id: ASESORIAS.HORARIOS_ASESORIAS, 
        path: "", 
        View: AppointmentSchedules 
    },
    { 
        id: ASESORIAS.CREAR_ASESORIAS, 
        path: "crear", 
        View: AppointmentManualLoadingForm
    }
];